import { render, staticRenderFns } from "./DocumentTypeForm.vue?vue&type=template&id=8701e768&scoped=true"
import script from "./DocumentTypeForm.vue?vue&type=script&lang=js"
export * from "./DocumentTypeForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentTypeForm.vue?vue&type=style&index=0&id=8701e768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8701e768",
  null
  
)

export default component.exports